import { useState, useCallback } from 'react'
import * as actions from '@actions'
import CustomModal from '@/components/shared/CustomModal/CustomModal'

/* type IRemoveRunsheetModal = {
    showRemove: boolean
    updateList: number
    showHideRemove: (showAdd: boolean) => void
    setUpdateList: (number: number) => void
    id: string
    name: string
} */

const RemoveRunsheetModal = ({
    showRemove,
    showHideRemove,
    id,
    name,
    updateList,
    setUpdateList,
}) => {
    
    const [isDeleting, setIsDeleting] = useState(false)
    
    const handleModal = useCallback(() => {
        showHideRemove(!showRemove)
    }, [showRemove, showHideRemove])
    
    const handleSubmit = async e => {
        
        e.preventDefault()
        setIsDeleting(true)
        
        await actions.deleteRunsheet(id)
        
        setIsDeleting(false)
        showHideRemove(!showRemove)
        setUpdateList(updateList + 1)
        
    }
    
    return (
        
        <CustomModal
            open={showRemove}
            center
            modalHandler={() => handleModal()}>
            
            <form onSubmit={handleSubmit}>
                
                <div className="modal-header flex flex-col">
                    {!isDeleting ? (
                        <>
                            <h2 className="modal-title">
                                Delete Runsheet
                            </h2>
                            <p className="my-5">
                                Are you sure you want to delete runsheet
                                {' '}
                                <span className="text-accent">&quot;{name}&quot;</span>?
                                {' '}
                                This cannot be undone.
                            </p>
                        </>
                    ) : (
                        <>
                            <h2 className="modal-title">Deleting runsheet</h2>
                            <p className="mt-2">{name}</p>
                        </>
                    )}
                </div>
                
                <div className="modal-footer flex justify-between">
                    <button
                        type="button"
                        className="mr-3 btn btn-primary btn-outline"
                        disabled={isDeleting}
                        onClick={handleModal}>
                        Cancel
                    </button>
                    
                    <button type="submit" className="btn btn-primary" disabled={isDeleting}
                        data-test-id="ConfirmationModalPositiveButton">
                        {isDeleting ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            
            </form>
        
        </CustomModal>
        
    )
    
}

export default RemoveRunsheetModal
